import React from "react";
import {SelectField} from "components/_defaultComponents/FilterComponents/FilterComponentStyles";

// Backend'deki Netsis fatura iletim durumlarıyla birebir aynı değerler
export const NETSIS_INVOICE_STATUSES = {
    PENDING: "pending",
    SUCCESS: "success",
    FAILED: "failed",
    RETRY: "retry"
};

export const NETSIS_INVOICE_STATUS_LABELS = {
    [NETSIS_INVOICE_STATUSES.PENDING]: "Beklemede",
    [NETSIS_INVOICE_STATUSES.SUCCESS]: "Başarılı",
    [NETSIS_INVOICE_STATUSES.FAILED]: "Başarısız",
    [NETSIS_INVOICE_STATUSES.RETRY]: "Tekrar Denenecek"
};

const STATUS_OPTIONS = [
    {value: NETSIS_INVOICE_STATUSES.PENDING, label: NETSIS_INVOICE_STATUS_LABELS.pending},
    {value: NETSIS_INVOICE_STATUSES.SUCCESS, label: NETSIS_INVOICE_STATUS_LABELS.success},
    {value: NETSIS_INVOICE_STATUSES.FAILED, label: NETSIS_INVOICE_STATUS_LABELS.failed}
    // RETRY listede yok: company-invoices endpoint'leri yalnızca success/pending/failed kabul ediyor
];

export const NetsisInvoiceStatusFilter = ({value, onChange}) => (
    <SelectField value={value} onChange={onChange}>
        <SelectField.Option value="all">Tümü</SelectField.Option>
        {STATUS_OPTIONS.map(status => (
            <SelectField.Option key={status.value} value={status.value}>
                {status.label}
            </SelectField.Option>
        ))}
    </SelectField>
);
